var exports = {
  "D": "xf0b3b88a--9d1c57--title",
};

module.exports = exports;
